export const validChecklistFieldsForColorModule = {
    SYSTEM_COLOR: 'p74018',
    COLOR_OF_THE_INSECT_SCREEN: 'p10063',
    OMARICA_ROLLER_SHUTTER_BOX_COLOR: 'p40178',
    VODILA_GUIDE_COLOR: 'p40119', // MANUAL REGISTRATION IN SILENTO.2 and HERO.5X is hidden
    COLOR_OF_THE_FLUSHMOUNTED_F_CORNER: 'p9090',
    OMARICA_SHEET_METAL_COLOR: 'p110209',
    COLOR_OF_THE_FLUSHMOUNTED_CORNER: 'p110216',
    COLOR_OF_THE_FINISHING_LAMELLA: 'p1031',
    OMARICA_BACK_COLOR: 'p10379', // NO MANUAL REGISTRATION IN VECTO
    COLOR_OF_THE_MOSQUITOS_NET_GUIDES: 'p82702',
    OMARICA_SERVICE_COVER_COLOR: 'p10385', // NON_STANDARD_COLOR is hidden in VISIO
    OMARICA_COVER_COLOR: 'p10366',
    MASKA: 'p9084',
};

export const checklistFieldsPIDsSet = new Set(Object.values(validChecklistFieldsForColorModule));
